export const APP_CONSTANTS = {
  APP_NAME: 'Bloodhound Admin',
  DEFAULT_DATE_FORMAT: 'MMM D, YYYY',
  DEFAULT_DATETIME_FORMAT: 'MMM D, YYYY h:mm A',
  DEFAULT_TIME_FORMAT: 'h:mm A',
  HTTP_STATUS: {
    OK: 200,
    CREATED: 201,
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    UNPROCESSABLE: 422,
    SERVER_ERROR: 500,
  },
  REQUEST_STATUS: {
    IDLE: 'idle',
    LOADING: 'loading',
    SUCCESS: 'success',
    ERROR: 'error',
  },
};
